import { useEffect } from "react";
import Navigation from "@/components/site/Navigation";
import Hero from "@/components/site/Hero";
import About from "@/components/site/About";
import AIMethodology from "@/components/site/AIMethodology";
import Projects from "@/components/site/Projects";
import Experience from "@/components/site/Experience";
import Toolkit from "@/components/site/Toolkit";
import Deliverables from "@/components/site/Deliverables";
import Personality from "@/components/site/Personality";
import Testimonials from "@/components/site/Testimonials";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import LiveStats from "@/components/site/LiveStats";
import JourneyMap from "@/components/site/JourneyMap";
import { useSectionTracking } from "@/components/site/Tracking";

export default function Home() {
  useEffect(() => {
    document.title = "Sinthu Nathan, Customer Insights & Growth Researcher";
  }, []);
  useSectionTracking();

  return (
    <>
      <Navigation />
      <main data-testid="home-main">
        <Hero />
        <JourneyMap />
        <LiveStats />
        <About />
        <Experience />
        <Personality />
        <Projects />
        <Deliverables />
        <AIMethodology />
        <Toolkit />
        <Testimonials />
        <Contact />
      </main>
      <Footer />
    </>
  );
}
